import * as React from 'react';
import { MediaQuery } from '@grandvisionhq/common';
import { useAddToProductViewHistory } from '@grandvisionhq/fun-products';
import { useReviewsContext, Actions } from '@grandvisionhq/reviews';
import Solutions$1 from './Solutions.js';
import { useSolutionsEcommContext } from './context/SolutionsEcommContext.js';
import { useBrandLink } from '../utils/use-brand-link.js';
import { CTAButton } from './Components/CTAButton/CTAButton.js';

const SolutionsContainer = ({ activeSku , addToCartRef , variant , product , showStickyButton , onCTAClick ,  })=>{
    const isSmallScreen = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    const { state , actions  } = useSolutionsEcommContext();
    const variants = React.useMemo(()=>[
            product.masterVariant,
            ...product.variants
        ]
    , [
        product.masterVariant,
        product.variants
    ]);
    useAddToProductViewHistory({
        variant,
        variants
    });
    const reviews = useReviewsContext();
    React.useEffect(()=>{
        if (reviews.enabled) {
            reviews.dispatch(Actions.updateReviewDisplay({
                variantId: activeSku
            }));
        }
    }, [
        activeSku,
        reviews
    ]);
    const isOrderable = (variant === null || variant === void 0 ? void 0 : variant.channelAvailability) === 'ONLINE';
    const brandLink = useBrandLink(product);
    const brandModel = `${variant.contactLensCareType} ${variant.packageOption}`;
    const ctaButton = /*#__PURE__*/ React.createElement(CTAButton, {
        isOrderable: isOrderable,
        activeSku: activeSku,
        addToCartCallback: onCTAClick
    });
    return /*#__PURE__*/ React.createElement(Solutions$1, {
        addToCartRef: addToCartRef,
        brandLink: brandLink,
        brandModel: brandModel,
        ctaButton: ctaButton,
        isSmallScreen: isSmallScreen,
        showStickyButton: showStickyButton,
        variant: variant,
        variants: variants,
        selectedQuantity: state.configurations.quantity,
        onQuantityChange: actions.updateQuantity,
        isOrderable: isOrderable
    });
};
var Solutions = SolutionsContainer;

export { SolutionsContainer, Solutions as default };
//# sourceMappingURL=SolutionsContainer.js.map
